/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type CSATFeature = (typeof CSATFeature)[keyof typeof CSATFeature];

export const CSATFeature = {
  curai_visit_concluded: "curai_visit_concluded",
  async_rx_concluded: "async_rx_concluded",
  async_dx_concluded: "async_dx_concluded",
  rx_renewal_concluded: "rx_renewal_concluded",
} as const;
